export default {
  'non_field_errors: [ Not enough money on your account to create an order ]':
    'Credit limit exceeded. Top up your personal account balance',
  'buyer: [ User has late payments ]': 'You have an expired payment. Please pay and try again.',
  'detail: No user credentials': 'Incorrect username or password',
  'phone_number: [ Phone number is already verified. ]': 'Phone number is already verified',
}
